import {openSocket} from "../util/socket";
import {setSocket} from "../action/socket";
import {setBaseAlert, setBaseAlertSocket, setCurrentAlertSocket} from "../action/alert";
import {updateDeviceInfo} from "../action/page";

export const openSocketConnection = data => (dispatch, getState) => {
    const stateGlob = getState();
    const {currentUser} = stateGlob;
    const arrayListenRooms = [
        {
            room: "alert",
            fn: (data) => {
                // if(currentUser.user.filter.findByCompanyId) return;
                // const state = getState();
                // const currentItem = state.page.currentItem;
                // dispatch(setBaseAlertSocket(data));
                // if(currentItem.mac === data.mac) {
                //     dispatch(setCurrentAlertSocket(data));
                // }
            }
        },{
            room: "updateDevice",
            fn: (data) => {
                // dispatch(updateDeviceInfo(data));
            }
        },{
            room: "newDevice",
            fn: (data) => {
                // if(
                //     currentUser.user.filter.findByCompanyId &&
                //     currentUser.user.companyId &&
                //     currentUser.user.companyId !== data.companyId
                // ) return;
                // dispatch(updateDeviceInfo(data));
            }
        }
    ]
    const socket = openSocket(data, arrayListenRooms);
    dispatch(setSocket({socket}));
}
